import React from 'react';
import ReactSpeedometer from 'react-d3-speedometer';
import { DASHBOARD_HEIGHT_SCALE } from '../dashboardLayout';

class BetaGaugeCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      guageWidth: 0
    };
    this.card = React.createRef();

    this.setGaugeWidth = () => {
      this.setState({
        guageWidth: this.card.current.clientWidth - 120
      });
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.setGaugeWidth);
    this.setGaugeWidth();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setGaugeWidth);
  }

  render() {
    const segmentColors=['#ebbb38', '#0ca616', '#cf3213'];
    const cardStyle = {
      paddingBottom: `${Math.round(55 * DASHBOARD_HEIGHT_SCALE)}px`
    };
    const betaValue = this.props.value ?? 1;
    const displayValue = this.props.value == null ? '—' : this.props.value;

    return (
      <div className="col-12 col-xl-3" ref={this.card}>
        <div className="card border-light shadow-sm">
          <div className="card-header d-flex flex-row align-items-center">
            <h2 className="h5 mb-0">Market Risk (Beta)</h2>
          </div>
          <div className="card-body" style={cardStyle}>
            <h2 className="display-1 text-center mb-2">{displayValue}</h2>
            <div className="d-flex justify-content-center">
              <span className="align-items-center gauge">
                <ReactSpeedometer forceRender={true} value={betaValue} minValue={0} maxValue={2} segments={3} maxSegmentLabels={0}
                  segmentColors={segmentColors} needleColor="#a6a6a6" currentValueText="" height={Math.round(190 * DASHBOARD_HEIGHT_SCALE)} width={this.state.guageWidth} ringWidth={36} />
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BetaGaugeCard;
